import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Technology = () => (
  <div style={{ fontFamily: "Arial, sans-serif" }}>
    {/* Заголовок страницы */}
    <section
      className="py-5 text-center"
      style={{ backgroundColor: "#ff6f00", color: "#FFF" }}
    >
      <h1 className="font-weight-bold">Our Technology</h1>
      <p className="lead mx-auto" style={{ maxWidth: "800px" }}>
        Empowering people, expanding technology — Imagine the possibilities.
      </p>
    </section>

    {/* Описание технологии */}
    <section className="bg-light py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h2>Empowering Travel</h2>
            <p>
              Expand your travel management potential with award-winning
              technology that works as hard as you do.
            </p>
            <p>
              Our consolidated travel platform, <strong>myccwtt</strong>, makes
              booking and managing travel seamless, whether online, mobile, or
              with our counselors.
            </p>
          </div>
          <div className="col-md-6">
            <img
              src="/images/technology.jpg"
              alt="Travel Technology"
              className="img-fluid rounded"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Основные функции */}
    <section
      className="py-5 text-center"
      style={{ backgroundColor: "#333", color: "#FFF" }}
    >
      <div className="container">
        <h2>Advanced Features</h2>
        <div className="row mt-4">
          <div className="col-md-4">
            <i className="fa fa-database fa-3x mb-3 text-warning" />
            <h4>Real-Time Data</h4>
            <p>
              Access up-to-date insights to manage your travel program
              effectively with our analytics.
            </p>
          </div>
          <div className="col-md-4">
            <i className="fa fa-mobile-alt fa-3x mb-3 text-warning" />
            <h4>Mobile Integration</h4>
            <p>
              Our app, myccwtt, offers travelers access to bookings and support
              anytime, anywhere.
            </p>
          </div>
          <div className="col-md-4">
            <i className="fa fa-user-shield fa-3x mb-3 text-warning" />
            <h4>Data Security</h4>
            <p>
              Keep travelers’ information safe with advanced security measures
              integrated into our technology.
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* Партнеры */}
    <section className="bg-light py-5 text-center">
      <div className="container">
        <h2>Our Trusted Partners</h2>
        <div className="row mt-4">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="col-md-3 col-6">
              <img
                src={`/images/partner${i + 1}.png`}
                alt={`Partner ${i + 1}`}
                className="img-fluid my-3"
              />
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Контактная информация */}
    <section
      className="py-5 text-center"
      style={{ backgroundColor: "#ff6f00", color: "#FFF" }}
    >
      <div className="container">
        <h2>Contact Us</h2>
        <p>
          Ready to empower your travel management with our technology? Reach out
          today.
        </p>
        <p>
          <strong>Email:</strong> info@myccwtt.com | <strong>Phone:</strong> +90
          850 777 2544
        </p>
      </div>
    </section>
  </div>
);

export default Technology;



// WEBPACK FOOTER //
// ./src/components/Technology/Technology.js